import OptionPage from "../components/optionPageStructure";
import { checkMissingSelections } from "../utils/checkMissingSelections";

export default function Heating() {
  return (
    <OptionPage
      title="Lämmitys ja laitteet"
      parentCategory="Lämmitys ja laitteet"
      previousParentCategory="Sähkökalusteet"
      currentStep="heating"
      nextRoute="/furniture-arrangement"
      imageMap={{
        
      }}
      checkMissingSelections={checkMissingSelections}
    />
  );
}
